import { render, staticRenderFns } from "./waterByTeacher.vue?vue&type=template&id=717b05f9&"
import script from "./waterByTeacher.vue?vue&type=script&lang=js&"
export * from "./waterByTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports